import { StatCard } from '@/common/dashboard/StatCard';
import { Spacer } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';

export const ChbkFinGrowthCards = ({ formValues, totalValues, ctrtTypeIdToCtrtType }) => {

  let { invPeriodId, invDate, periodicity, distCustIds, ctrtTypeIds, prodIds, agg } = formValues;

  const { totalProdIds, totalDistCustIds } = totalValues;

  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    if (!invPeriodId && !invDate) {
        return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }

    let distCustIdsNot = true;
    if (totalDistCustIds.length / 2 < distCustIds.length) {
      distCustIds = totalDistCustIds.filter(id => !distCustIds.includes(id));
    } else {
      distCustIdsNot = false;
    }

    const reqParam = {
      periodId: invPeriodId,
      invDate,
      distCustIds,
      distCustIdsNot,
      ctrtTypes: ctrtTypeIds.map(id => ctrtTypeIdToCtrtType[id]),
      prodIds,
      prodIdsNot,
      agg
    };

    rsrc.data('sc', 'CHBK_FIN_GROWTH_CARDS_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });
  }, [invPeriodId, invDate, distCustIds, ctrtTypeIds, prodIds, agg]);

  return (
    <Spacer>
      <Spacer vertical>
        <StatCard
          title={(periodicity === 'DAY' ? 'Week over Week' : 'YoY') + ' Distributor Decrease'}
          flex={1}
          val={data?.largestDistCustAmtDecrease}
          isAmt={agg === 'PAID_AMT'}
          pctChange={data?.largestDistCustPctDecrease === 0 ? null : data?.largestDistCustPctDecrease}
          vsLabel={data?.priorPeriodCode}
          label={data?.distCustName}
        />
        <StatCard
          title={(periodicity === 'DAY' ? 'Week over Week' : 'YoY') + ' Brand Decrease'}
          flex={1}
          val={data?.largestBrandAmtDecrease}
          isAmt={agg === 'PAID_AMT'}
          pctChange={data?.largestBrandPctDecrease === 0 ? null : data?.largestBrandPctDecrease}
          vsLabel={data?.priorPeriodCode}
          label={data?.brandCode}
        />
        {/* <StatCard
          title="Largest YoY Contract Decrease"
          flex={1}
          val={data?.largestCtrtAmtDecrease}
          isAmt={agg === 'PAID_AMT'}
          pctChange={data?.largestCtrtPctDecrease}
          vsLabel={data?.priorPeriodCode}
          label={data?.ctrtType}
        /> */}
      </Spacer>
    </Spacer>
  )

}